import React, {Component} from 'react';
import {Link, withRouter} from 'react-router-dom';
import auth0Client from '../Auth';
import QuickClaim from '../Claim/QuickClaim';

import Modal from 'react-responsive-modal';
//import { formatRelativeWithOptions } from 'date-fns/fp';
import SelectAccounts from './SelectAccount';


class NavBar extends Component {
  constructor(props) {
    super(props);
     this.state ={
       showQuickClaim:false,
       venueTypeCd:'',
       showAccounts:false,
       showClaimFlowLink:false,
       clipboardButtonTitle:'Copy',
       show:false,
       disableQuickClaim:false,
      }
    // console.log(props);
   // this.navRef = React.createRef();

  

  }
  async componentDidMount() {
   // console.log(auth0Client);
   if (auth0Client.lfReadOnly===true){
    this.setState({
      disableQuickClaim:true
    })
   }

    
}
 
//**** this is the menu item for quick claim drop-down version */
  renderQuickClaimAndClaimFlowButton=()=>{
    return(
      <li className="nav-item dropdown">
      <a className="btn btn-outline-success btn-sm dropdown-toggle" href="/#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            Quick Claim
      </a>
      <div className="dropdown-menu bg-primary" aria-labelledby="navbarDropdown">
      
            <button className="btn btn-primary" type="button" onClick={() => {this.showQuickClaim()}}>Quick Claim</button>
            <br/>
            <button className="btn btn-primary" type="button" onClick={() => {this.showClaimClowLink()}}>ClaimFlow Link</button>
      </div>
     
      </li>
    )
  }


   signOut = () => {
    auth0Client.signOut();
    this.props.history.replace('/');
  };

   signIn =()=>{
    //console.log('dashboard');
    this.props.history.push('/Dashboard');
  }

  onCloseClaimModal = () => {
    this.setState({ showQuickClaim: false });
  };

  showQuickClaim=()=>{
    this.setState({ showQuickClaim: true });
  }
  showClaimClowLink=()=>{
    this.setState({ showClaimFlowLink: true });
  }
renderClaimFlowLink = ()=>{
  

  
    return(
      
      <Modal open={this.state.showClaimFlowLink} onClose={()=>{this.setState({showClaimFlowLink:false})}} center closeOnEsc={true} closeOnOverlayClick={false} styles={{ overlay: { zIndex:"1000000"} }} >
          
         <div style={{width:700}}>
            <h5>ClaimFlow Link</h5>
            <hr/>
            <br/>
            <h5>Email Link</h5>
            <button className="btn btn-outline-primary btn-sm"
           
            onClick={(e) => {
                window.location.href ='mailto: ?subject=Submit Your Lost and Found Claim Report&body=Use the following link to submit a claim: \n' + this.props.claimFlowUrl + '';
                e.preventDefault();
            }}
        >
            Mail ClaimFlow&trade; Link
        </button>
        <br/><br/>
        <h5>Copy Link</h5>
            
            <small>Copy and paste this link in an email or text:</small>
            <br/>
            <div class="input-group mb-3">
              <input type="text" class="form-control" autocomplete="off" data-lpignore="true" value={this.props.claimFlowUrl} placeholder="" aria-label="ClaimFlow Link" aria-describedby="button-addon2"/>
                        <button className="btn btn-info"
                        
                        onClick={(e) => {
                          navigator.clipboard.writeText(this.props.claimFlowUrl);
                            e.preventDefault();
                            this.setState({clipboardButtonTitle:'Done!'})
                        }}>
                        {this.state.clipboardButtonTitle}
                       </button>
              </div>
         </div>

      </Modal>  
    )
  }
  renderQuickClaim = ()=>{
  
    return(
      
      <Modal open={this.state.showQuickClaim} onClose={this.onCloseClaimModal} center closeOnEsc={true} closeOnOverlayClick={false} styles={{ overlay: { zIndex:"1000000" } }} >
          
          <QuickClaim onClose={this.onCloseClaimModal}></QuickClaim>

    </Modal>  
    )
  }
  renderQuickClaimButton = ()=>{
  
    return(
      <button className="btn btn-success btn-sm" disabled={auth0Client.lfReadOnly===true} type="button" onClick={() => {this.showQuickClaim()}}>Quick Claim </button>

    )
  }

  showAccounts=()=>{
    this.setState({
      showAccounts: true
    })
  }

  onCloseAccounts=()=>{
    this.setState({
      showAccounts: false
    })
  }
  onCloseAndRefresh=()=>{
    this.setState({
      showAccounts: false
    });
    console.log('naviagate to /');
    this.props.history.push('/');
    window.location.reload();
  }

  renderVenueName(){
   
     
      return (
       
   
        <Link className="nav-link" to="/Venue" >  <small className="text-info " >{this.props.venueName}</small></Link>
      
      )
  
  }

   handleNavClick = () => {
    this.setState({show:false})
  };


  renderAIM(){
    //if (this.state.venueTypeCd==='A'){
      return (
        <li className="nav-item">
        <Link className="nav-link" to="/AIM" >AIM</Link>
        </li>
      );

    //}else{
    //  return (null);
    //}
  }
  renderSR(){
   
      return (
        <li className="nav-item">
        <Link className="nav-link" to="/SRItems" >Parcel</Link>
        </li>
      );

   
  }
  render() {
  // <button className="btn btn-dark" onClick={() => {signIn()}}>Sign In</button>
  //console.log('Warehouse enabled:' + this.props.enableWarehouse);

  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-primary fixed-top" >
      <Link className="navbar-brand" to="/">BOUNTE&trade;</Link>

      <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarColor01" aria-controls="navbarColor01" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
        </button>
  

      <div className="collapse navbar-collapse" id="navbarColor01" >
        <ul className="navbar-nav mr-auto">
       
        <li className="nav-item active">
          {this.renderQuickClaimAndClaimFlowButton()}
        </li>
        
       

            <li className="nav-item active">
              <Link className="nav-link" to="/Dashboard" >Dashboard </Link>
            </li>
            <li className="nav-item">
            <Link className="nav-link" to="/LostItems"  >Found Items</Link>
            </li>
            <li className="nav-item">
            <Link className="nav-link" to="/Claims" >Claims</Link>
            </li>
            
            
        {this.renderAIM()}
        {this.renderSR()}

       {
        (this.props.enableDisposition) ?  <li className="nav-item"><Link className="nav-link" to="/Disposition" >Disposition</Link></li> : null
       }

      
       

            <li className="nav-item">
            <Link className="nav-link" to="/ShipCentral" >Ship</Link>
            </li>
            <li className="nav-item">
            <Link className="nav-link" to="/Reports" >Reports</Link>
            </li>

            <li className="nav-item dropdown">
                    <a className="nav-link dropdown-toggle" href="/#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      Settings
                    </a>
                    <div className="dropdown-menu bg-primary" aria-labelledby="navbarDropdown">
                       
                       <Link  to="/Locations" className="nav-link">Locations</Link> 
                      
                       
                        <Link  to="/Users" className="nav-link">Users</Link>
                        <Link  to="/Venue" className="nav-link">Venue</Link>
                       
                        <Link  to="/Docs" className="nav-link">Help</Link>
                        <button className="btn btn-dark" onClick={() => {this.showAccounts()}}>Switch Accounts...</button>
                      </div>
                  </li>
               
          <li className="nav-item active">{this.renderVenueName()}</li>
        

          </ul>
          <form className="form-inline my-2 my-lg-0">
              {
                    !auth0Client.isAuthenticated() &&
                    <Link className="nav-link text-white" to="/Dashboard" >Sign In </Link>
                  }
                  {
                    auth0Client.isAuthenticated() &&
                    <div>
                  
                      <button className="btn btn-dark" onClick={() => {this.signOut()}}>Sign Out</button>
                    </div>
                  }
          </form>

        </div>
     
        
       
    {this.renderQuickClaim()}
    {this.renderClaimFlowLink()}
    <Modal open={this.state.showAccounts} onClose={this.onCloseAccounts} center closeOnEsc={true} closeOnOverlayClick={false} styles={{ overlay: { zIndex:"1000000" } }} >
          
    <SelectAccounts onCloseAndRefresh={this.onCloseAndRefresh} close={this.onCloseAccounts}></SelectAccounts>

    </Modal>  
    </nav>
  );
  }
}

export default withRouter(NavBar);